import { render } from "./AdmCreateProfessor.vue?vue&type=template&id=542b057a&scoped=true&ts=true"
import script from "./AdmCreateProfessor.vue?vue&type=script&lang=ts"
export * from "./AdmCreateProfessor.vue?vue&type=script&lang=ts"

import "./AdmCreateProfessor.vue?vue&type=style&index=0&id=542b057a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542b057a"]])

export default __exports__